/**
 * Datenbank-Typen: spiegeln TABELLEN, nicht das Produktmodell.
 *
 * Handgepflegt und absichtlich nur so breit wie das, was der Repository Layer
 * wirklich anfasst. Sobald ein echtes Supabase-Projekt existiert, wird diese
 * Datei durch
 *     supabase gen types typescript --project-id <id> > database.types.ts
 * ersetzt. Bis dahin gilt: Quelle der Wahrheit bleiben die SQL-Migrationen.
 *
 * WICHTIG: Diese Typen werden NIE in die UI exportiert. Das Mapping auf die
 * Domain Types (@plathunt/types) passiert ausschliesslich im Repository.
 */
export const GAME_COLUMNS = 'id, title, slug, franchise_id, cover_url, release_date, publisher, developer, platforms, support_state, igdb_id';
export const FRANCHISE_COLUMNS = 'id, name, slug, popularity_rank, igdb_id';
export const TROPHY_SET_COLUMNS = 'id, game_id, np_communication_id, platform, region, version, title, trophy_title_icon_url, ' +
    'count_bronze, count_silver, count_gold, count_platinum, count_total, has_platinum, support_state, psn_last_synced_at';
//# sourceMappingURL=database.types.js.map